/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Saved_To_NotesInputs */

const en_funnel_saved_to_notes = /** @type {(inputs: Funnel_Saved_To_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved to your notes`)
};

const es_funnel_saved_to_notes = /** @type {(inputs: Funnel_Saved_To_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardado en tus notas`)
};

/**
* | output |
* | --- |
* | "Saved to your notes" |
*
* @param {Funnel_Saved_To_NotesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_saved_to_notes = /** @type {((inputs?: Funnel_Saved_To_NotesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Saved_To_NotesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_saved_to_notes(inputs)
	return en_funnel_saved_to_notes(inputs)
});